export default "__VITE_ASSET__8271b474__"